import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";
import type { SelectNotification } from "@shared/schema";

export interface NotificationsResponse {
  notifications: SelectNotification[];
  unreadCount: number;
}

export function useNotifications() {
  const { user } = useAuth();
  return useQuery<NotificationsResponse>({
    queryKey: ["/api/notifications"],
    enabled: !!user,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
}

export function useUnreadNotificationCount(): number {
  const { data } = useNotifications();
  return data?.unreadCount ?? 0;
}
